import React from 'react'
import { connect } from 'react-redux';
import {change as changeFieldValue } from 'redux-form';
import adicionarFormasPagamentoEncomenda from '../../actions/encomenda/adicionarFormasPagamentoEncomenda';
import {bindActionCreators} from 'redux';

export class FormasPagamento extends React.Component {

  removerFormaPagamento () {
    this.props.changeFieldValue('formularioCadastroEncomenda',
      'dinheiro', false);
      this.props.changeFieldValue('formularioCadastroEncomenda',
      'cartao', false);
      this.props.changeFieldValue('formularioCadastroEncomenda',
      'pix', false);
    const valorTotal = 0;
    
    this.props.changeFieldValue('formularioCadastroEncomenda',
    'valorDinheiro', valorTotal.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }));

    this.props.verificarSeFormaPagamentoNaoFoiSelecionado(false, false, false, false);
  }

  render () {
    if (this.props.dadosPagamentoEncomenda.formasPagamento.length) {
      return (
        <React.Fragment>
          <table className="table table-striped table-sm table-bordered text-center mt-2">
            <thead>
            <tr>
              <td colSpan={4} className='text-center'>
                <strong>Formas de Pagamento</strong>
              </td>
            </tr>
            <tr>
              <th scope="col">Tipo</th>
              <th scope="col">Valor</th>
              <th scope="col">Parcelas</th>
              <th scope="col">Número comprovante</th>
            </tr>
            </thead>
            <tbody>
            {this.props.dadosPagamentoEncomenda.formasPagamento.map((forma, index) => <tr key={index}>
              <td>{forma.tipo}</td>
              <td>{(forma.valor).toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              })}</td>
              <td>{forma.quantidadeParcelas ? forma.quantidadeParcelas : '-'}</td>
              <td>{forma.numeroComprovante ? forma.numeroComprovante : '-'}</td>
            </tr>)
            }
            </tbody>
            {this.props.exibeRemover ? <tfoot>
            <td colSpan={4} className='text-center'>
              <button type="button" className="btn btn-excluir" style={{ color: 'red' }}
                      onClick={() => {this.props.adicionarFormasPagamentoEncomenda([])
                      this.removerFormaPagamento()}}>
                <span>Remover</span>
              </button>
            </td>
            </tfoot> : ''}
          </table>
        </React.Fragment>
      )
    }
    return '';
  }
}

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    adicionarFormasPagamentoEncomenda
  }, dispatch)
);

export const mapStateToProps = state => (
  {
    dadosPagamentoEncomenda: state.dadosPagamentoEncomenda
  });

export default connect(mapStateToProps, mapDispatchToProps)(FormasPagamento)
